export default __webpack_public_path__ + "static/media/24H_Aqua_Light_Blue.8e638489.png";